<template>
    <el-form status-icon :model="ccmForm" :rules="rulesCCM" ref="ccmForm" @submit.native.prevent="enter"
             class="demo-ruleForm">
        <div>
            <el-row>
                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                    <el-form-item label='CCM Adı' class="margin-top-20"
                                  prop="ccmAdi">:
                        <el-input
                                v-model="ccmForm.ccmAdi"
                                placeholder='CCM Adı Giriniz'></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </div>
        <el-row class="col-p">
            <el-form-item>
                <el-button size="small" v-on:click="ccmTanimla('ccmForm')"
                           type="primary">
                    Tanımla
                </el-button>
            </el-form-item>
        </el-row>
    </el-form>

</template>

<script>
    import EventBus from '@/components/event-bus'

    import ccmService from '../../../../WSProvider/OpsiyonService'
    import notification from '../../../../notification'
    export default {
        name: "CCMEkle",
        mounted() {
            this.getCCMListesi();
        },
        data() {
            return {
                ccmListesi: [],
                ccmForm: {
                    ccmAdi: '',
                },
                rulesCCM: {
                    ccmAdi: [{
                        required: true,
                        message: "Lütfen CCM Giriniz",
                        trigger: 'blur'
                    }],
                },
            }
        },
        methods: {
            getCCMListesi() {
                    ccmService.ccmList(1, "", "").then((response) => {
                    if (response.status === 200) {
                        this.ccmListesi = response.data;
                    } else {
                        notification.Status(response.status, this)
                    }
                });
            },
            ccmTanimla(formName) {
                var dizi = [];
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        ccmService.ccmTanimlama(this.ccmForm.ccmAdi).then((response) => {
                            if (response.status === 200) {
                                this.ccmListesi.push(response.data);
                                this.ccmListesi.forEach(function (value) {
                                    dizi.push({
                                        secenekAdi: value.ccmAdi,
                                        secenekKodu: value.ccmKodu,
                                    })
                                });
                                EventBus.$emit("opsiyonList", true)
                                // this.$store.commit('changeOpsiyonList', dizi);
                                notification.Status('success', this, 'CCM başarıyla eklendi.');
                                this.$refs[formName].resetFields();
                            } else if (response.status === 230) {
                                notification.Status('warning', this, 'Bu bilgiler ile kayıtlı bir ccm zaten mevcut');
                            } else {
                                notification.Status(response.status, this)
                            }
                        });
                    }
                })
            },
        }
    }
</script>

<style scoped>

</style>